<header class="page-header-actions tw:flex tw:justify-between tw:min-w-0">
  <div>
    @if (eyebrow()) {
      <span class="page-header-actions__eyebrow">
        {{ eyebrow() | translate }}
      </span>
    }
    <h1>
      @if (useTranslate()) {
        {{ title() | translate }}
      } @else {
        {{ title() }}
      }
    </h1>
    @if (description()) {
      <p>
        {{ description() | translate }}
      </p>
    }
  </div>

  <div class="page-header-actions__actions tw:inline-flex">
    @for (action of actions(); track action.id) {
      <button [class.page-header-actions__secondary]="action.variant === 'secondary'"
        [class.page-header-actions__primary]="action.variant !== 'secondary'"
        [ngClass]="action.cssClass"
        type="button"
        (click)="onActionClick(action.id)">
        @if (action.icon) {
          <ion-icon [name]="action.icon"></ion-icon>
        }
        @if (action.prefix) {
          <span>{{ action.prefix }}</span>
        }
        @if (useTranslate()) {
          <span>{{ action.label | translate }}</span>
        } @else {
          <span>{{ action.label }}</span>
        }
      </button>
    }
  </div>
</header>